const colorsRemap: Record<string, string> = {
    'ade55c': '49B32C'
};

export const getItemColor = (color?: string) => {
    return color ? colorsRemap[color.toLowerCase()] || color : 'FF8B00';
};
